import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { BookingPageTagName } from '../../../../../domain/entities/BookingPage';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import BookingPageCard from '../../../common/cards/BookingPageCard';
import PurchaseLabeledContainer from './PurchaseLabeledContainer';

import css from './AvailableBookingPageList.module.scss';

interface Props {
  className?: string;
  publicId: string;
  bookingPages: IPurchases.BookingPage[];
}

const tagsBy = (page: IPurchases.BookingPage) => {
  const tags = [];
  if (page.tagNames.includes(BookingPageTagName.Accepting)) {
    tags.push('accepting');
  }
  return tags;
};

const AvailableBookingPageList = ({
  className,
  publicId,
  bookingPages,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.AvailableBookingPageList, className);

  return (
    <PurchaseLabeledContainer
      className={classes}
      label={intl.formatMessage({
        id: `purchases.availableBookingPageList.title`,
      })}
      paddingTop={true}
    >
      {bookingPages.map((page, i) => (
        <BookingPageCard
          key={i}
          className={css.AvailableBookingPageList__BookingPageCard}
          title={page.name}
          description={page.descriptionText || ''}
          url={`/${publicId}/${page.publicId}#pageContent`}
          thumbnailUrl={
            page.primaryImage && page.primaryImage.thumb
              ? page.primaryImage.thumb.url
              : ''
          }
          tags={tagsBy(page)}
        />
      ))}
    </PurchaseLabeledContainer>
  );
};

export default injectIntl(AvailableBookingPageList);
